import React from 'react'

import Section from 'components/Section/Section'
import Container from 'components/Container/Container'

import ManageReservations from 'assets/images/manage_reservations.png'
import ConnectPlayers from 'assets/images/connect_players.png'
import SaveTime from 'assets/images/save_time.png'

import {
  FacilitiesGrid,
  FacilitiesTitleSection,
  FacilitiesItem,
  FacilitiesImage,
  FacilitiesTitle,
  FacilitiesText,
  FacilitiesActions,
  FacilitiesLink,
} from './HomeFacilities.styled'

const HomeFacilities = () => {
  return (
    <Section>
      <Container size="medium">
        <FacilitiesTitleSection
          color="primary"
          weight="bold"
          align="center"
          preset="h3">
          AceSpace Facilities can
        </FacilitiesTitleSection>
        <FacilitiesGrid>
          <FacilitiesItem>
            <FacilitiesImage
              src={ManageReservations}
              alt="Manage Reservations"
            />
            <FacilitiesTitle
              color="blackSecondary"
              weight="bold"
              align="center"
              preset="h4">
              Manage Reservations
            </FacilitiesTitle>
            <FacilitiesText color="fontMain" align="center">
              Manage player bookings from anywhere, with the press of a button
            </FacilitiesText>
          </FacilitiesItem>
          <FacilitiesItem>
            <FacilitiesImage src={ConnectPlayers} alt="Connect with Players" />
            <FacilitiesTitle
              color="blackSecondary"
              weight="bold"
              align="center"
              preset="h4">
              Connect with Players
            </FacilitiesTitle>
            <FacilitiesText color="fontMain" align="center">
              Collaboratively administrate empowered markets via plug-and-play
              networks. Dynamically procrastinate.
            </FacilitiesText>
          </FacilitiesItem>
          <FacilitiesItem>
            <FacilitiesImage src={SaveTime} alt="Save Time" />
            <FacilitiesTitle
              color="blackSecondary"
              weight="bold"
              align="center"
              preset="h4">
              Save Time
            </FacilitiesTitle>
            <FacilitiesText color="fontMain" align="center">
              Leverage agile frameworks to provide a robust synopsis for high
              level overviews. Iterative approaches.
            </FacilitiesText>
          </FacilitiesItem>
        </FacilitiesGrid>
        <FacilitiesActions>
          <FacilitiesLink color="primary" preset="link" align="center">
            How it works
          </FacilitiesLink>
        </FacilitiesActions>
      </Container>
    </Section>
  )
}

export default HomeFacilities
